module.exports = __webpack_public_path__ + "static/sdfyy-7e38717419e0b4bbe19d2674d6595ff1.jpg";